/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import getTimeString from '@ts-core/utils/getTimeString';

const AssignmentResultTimeCell = (props) => {
  const { time, timeLimit } = props;

  if (!time) return '-';

  const timeInSeconds = time * 60;

  return (
    <Box
      color={timeLimit > 0 && timeLimit < time ? 'error.main' : 'text.primary'}
    >
      {getTimeString(timeInSeconds)}
    </Box>
  );
};

AssignmentResultTimeCell.propTypes = {
  time: PropTypes.number,

  timeLimit: PropTypes.number,
};

AssignmentResultTimeCell.defaultProps = {
  time: undefined,
  timeLimit: 0,
};

export default AssignmentResultTimeCell;
